import { useEffect, useState } from "react";
import {
  EntryForm,
  Column,
  Input,

  TextArea,
} from "../components/EntryForm";



import { useUserProvider } from "../providers/UserProvider";

import { useFormik } from "formik";
import CopyIcon from "../components/CopyIcon";
import { Tooltip } from "@material-ui/core";
import BaseModal from "./BaseModal";

const AppInfoModal = ({ open, handleClose }) => {
  const [initialValues, setInitialValues] = useState({
    username: "",
  });

  const { user } = useUserProvider();


  useEffect(() => {
    const setup = user.app_data?.setup;
    const onboarding = user.app_data?.onboarding;
    const graphicsIds = onboarding?.app_designed_graphics?.map(a => {
      return a?.split(':')?.[1]
    });
    setInitialValues({
      app_name: user.app_data.name,
      tagline: setup?.header?.tagline,
      app_designed_colors: onboarding.app_designed_colors,
      setup: setup,
      app_designed_fonts: onboarding.app_designed_fonts,
      app_designed_graphics_download_url:
        onboarding.app_designed_graphics_download_url,
      appDesignGraphicsIds: graphicsIds,
      qrcode_download_url: onboarding.qrcode_download_url,
      qrcode: onboarding.qrcode,
      screens_download_url: onboarding.screens_download_url,
      play_store_link: onboarding.play_store_link,
      app_store_link: onboarding.app_store_link,
      username: user.app_data.username,
      media_metadata: onboarding.media_metadata,
    });
  }, [user.app_data]);


  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
  });


  return (
    <BaseModal
      modalOpen={open}
      customContentStyle={{
        width: "70vw",
        minHeight: "70vh",
      }}
      handleClose={handleClose}
    >
      <div className="absolute right-10 cursor-pointer text-xl" onClick={handleClose}>
        x
      </div>
      <EntryForm
        formik={formik}
        hideSubmit={true}
        removeStyle={true}
      >
        <Column>
          <div className="w-full">
            <div className="flex flex-col">
              <Input
                withCopyButton
                wrapperClassName="w-full"
                className="w-full"
                name="app_name"
                type="text"
                label="App Name"
                disabled
                formik={formik}
                labelClassName="flex flex-row items-center"
              />
              <Input
                withCopyButton
                wrapperClassName="w-full"
                className="w-full"
                name="tagline"
                type="text"
                label="Tagline"
                disabled
                formik={formik}
                labelClassName="flex flex-row items-center"
              />
              <TextArea
                withCopyButton
                wrapperClassName="w-full"
                className="w-full"
                name="app_designed_fonts"
                labelClassName="flex flex-row items-center"
                type="text"
                label="Fonts"
                disabled
                formik={formik}
              />
              <TextArea
                withCopyButton
                wrapperClassName="w-full"
                className="w-full"
                labelClassName="flex flex-row items-center"
                name="app_designed_colors"
                type="text"
                label="Colors"
                disabled
                formik={formik}
              />
              <div className="text-lg mb-2 mt-5">Marketing Graphics</div>
              {formik.values.appDesignGraphicsIds && (
                <>
                  {formik.values.appDesignGraphicsIds.map((id) => {
                    const graphic = formik.values.media_metadata[id];
                    return (
                      <div key={id} className="flex flex-row items-center gap-2">
                        <div
                          className="underline cursor-pointer font-bold"
                          style={{
                            color: "#3091ce",
                          }}
                          onClick={async (e) => {
                            e.preventDefault();
                            const response = await fetch(
                              graphic?.url_with_extension
                            );
                            const blob = await response.blob();
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.download = graphic?.filename;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            // Release the reference to the blob
                            URL.revokeObjectURL(url);
                          }}
                        >
                          {graphic?.filename}
                        </div>
                        <CopyIcon value={graphic?.url_with_extension} />
                      </div>
                    );
                  })}
                  </>
              )}
            </div>
          </div>
        </Column>
        <Column>
          <div className="w-full">
            <div className="flex flex-col">
              <div className="text-lg mb-2 mt-5">QR Code</div>
              {formik.values.qrcode_download_url && (
                <div
                  className="underline font-bold"
                  style={{
                    color: "#3091ce",
                    cursor: "pointer",
                  }}
                  onClick={async (e) => {
                    e.preventDefault();
                    const response = await fetch(
                      formik.values.qrcode_download_url
                    );
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = formik.values.app_name + "_qr_code.png";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    // Release the reference to the blob
                    URL.revokeObjectURL(url);
                  }}
                >
                  <img
                    src={formik.values.qrcode_download_url}
                    alt="qr"
                    style={{
                      width: 200,
                      height: 200,
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
              {formik.values.qrcode && (
                <div className="flex flex-row items-center gap-2">
                  <a
                    className="underline font-bold"
                    style={{
                      color: "#3091ce",
                    }}
                    href={formik.values.qrcode}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {formik.values.qrcode}
                  </a>
                  <CopyIcon value={formik.values.qrcode} />
                </div>
              )}
            </div>
            <div className="flex flex-col">
              <div className="text-lg mb-2 mt-5">Screenshots (Zip)</div>
              {formik.values.screens_download_url && (
                <a
                  className="underline font-bold"
                  style={{
                    color: "#3091ce",
                  }}
                  href={formik.values.screens_download_url}
                  rel="noreferrer"
                >
                  Zip File
                </a>
              )}
            </div>
            <div className="flex flex-col">
              <div className="text-lg mb-2 mt-5">Google Play Link</div>
              {formik.values.play_store_link && (
                <div className="flex flex-row items-center gap-2">
                  <a
                    className="underline font-bold"
                    style={{
                      color: "#3091ce",
                      maxWidth: "300px",
                      display: "inline-block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    href={formik.values.play_store_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {formik.values.play_store_link}
                  </a>
                  <CopyIcon value={formik.values.play_store_link} />
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="text-lg mb-2 mt-5">Apple Link</div>
            {formik.values.app_store_link && (
              <div className="flex flex-row items-center gap-2">
                <Tooltip title={formik.values.app_store_link}>
                  <a
                    className="underline font-bold"
                    style={{
                      color: "#3091ce",
                      maxWidth: "300px",
                      display: "inline-block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    href={formik.values.app_store_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {formik.values.app_store_link}
                  </a>
                </Tooltip>
                <CopyIcon value={formik.values.app_store_link} />
              </div>
            )}
          </div>
          <div className="flex flex-col">
            <div className="text-lg mb-2 mt-5">WEB URL</div>
            <div className="flex flex-row items-center gap-2">
              <a
                className="underline font-bold"
                style={{
                  color: "#3091ce",
                }}
                href={`${process.env.REACT_APP_WEB_FQDN}/${formik.values.username}`}
                target="_blank"
                rel="noreferrer"
              >
                {process.env.REACT_APP_WEB_FQDN}/{formik.values.username}
              </a>
              <CopyIcon
                value={`${process.env.REACT_APP_WEB_FQDN}/${formik.values.username}`}
              />
            </div>
          </div>
        </Column>
      </EntryForm>
    </BaseModal>
  );
};

export default AppInfoModal;

